module.exports = __webpack_public_path__ + "static/media/mining-bg.8142a41c.png";